module.exports = {
    Analytics: {
        InternalDomains: process.env.allowed_origins,
        origin: window.location.origin,
        NavDelay: 2e3,
        source: 'NextIT',
        type: 'Analytics',
    },
    MaintainAnalytics: process.env.maintain_analytics,
};


// WEBPACK FOOTER //
// ./settings/analytics.js